type ListenerRegistry = {
    add: (_event: string, _listenerId: string) => void
    remove: (_event: string, _listenerId: string) => void
    removeAll: (_event: string) => void
    getAll: (_event: string) => ReadonlyArray<string>
}

export const createListenerRegistry = (): ListenerRegistry => {
    const listeners = new Map<string, string[]>()

    const add = (event: string, listenerId: string) => {
        const existing = listeners.get(event)
        if (existing) {
            existing.push(listenerId)
            return
        }
        listeners.set(event, [listenerId])
    }

    const remove = (event: string, listenerId: string) => {
        const existing = listeners.get(event)
        if (!existing) return

        const next = existing.filter(id => id !== listenerId)
        if (next.length === 0) {
            listeners.delete(event)
            return
        }
        listeners.set(event, next)
    }

    const removeAll = (event: string) => {
        listeners.delete(event)
    }

    const getAll = (event: string): ReadonlyArray<string> => {
        return listeners.get(event) ?? []
    }

    return { add, remove, removeAll, getAll }
}
